import { Injectable } from '@angular/core';
import { GlobalService } from '../core/global.service';
import { GlobalNamespace as _GlobalNS } from '../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { RecipientGroup, Message } from './message';


@Injectable({
  providedIn: 'root'
})
export class MessageService {

  constructor(private _http: HttpClient, private _global: GlobalService) { }

  findRecipientByProperty(PropertyId: number): Observable<RecipientGroup> {
    const api = (<any>_GlobalNS).api.message.send;
    const noteId = this._global.find((<any>_GlobalNS).paths.noteId);
    return this._http.get<any>(`${api}&Property_Id=${PropertyId}&note_Id=${noteId}`, {});
  }

  addMessage(message: any, PropertyId: number): Observable<any> {
    const api = (<any>_GlobalNS).api.message.send;
    const eqrf = this._global.find((<any>_GlobalNS).paths.eqrf);
    return this._http.post<any>(`${api}&Property_Id=${PropertyId}&eqrf=${eqrf}`, message);
  }
}
